module.exports = __webpack_public_path__ + "img/f_logo.9eb762c6.png";